document.addEventListener('quickview:loaded', function(evt) {
  //RCP added 12/5/2024 to hide the 'Buy with ShopPay' button
 var gravityButton = document.querySelector('.shopify-payment-button');
 var addToCartButton = document.querySelector('.payment-buttons .add-to-cart--secondary');
 if (gravityButton) {
    gravityButton.style.display = 'none';
 }
 
 if (addToCartButton) {
   addToCartButton.style.backgroundColor = '#0eaba0';
   addToCartButton.style.setProperty('background-color', '#0eaba0', 'important');
   addToCartButton.style.setProperty('color', '#ffffff', 'important');
   
 }

});


